import React from "react";
import { Formik, Field } from "formik";
import { CTA, InputField } from "@coverme/forms";
import "./Retrocheck.scss";
import { SimpleSingleSelect } from "../FormComponents/SimpleSingleSelect";
import { LabelledCheckbox } from "../FormComponents/Checkbox"

export const RetrocheckFileInfoFilters = ({ submitFilter }) => {
    const onFormReset = () => {
        let multiValRemove = document.getElementsByClassName("css-1alnv5e multi-select__multi-value__remove");
        let removeLength = multiValRemove.length;

        for (let i = 0; i < removeLength; i++) {
            setTimeout(function () {
                multiValRemove[0].click();
            }, 100);
        }
    };

    const extractFilter = formData => {
        const dataToSend = { ...formData };
        return dataToSend;
    };

    const onFormSubmit = formData => {
        const dataToSend = extractFilter(formData);
        submitFilter(dataToSend);
    };

    const initialValues = { EncounterStatuses: [], ProgramStatuses: [] };
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={onFormSubmit}
            onReset={onFormReset}
            render={props => {
                const {
                    setFieldValue,
                    handleSubmit,
                    setFieldTouched,
                    values,
                } = props;
                return (
                    <div>
                        <form id="retrocheckFiltersForm">
                            <div className="retrocheck-filters">
                                <div className="retrocheck__bottom-container">
                                    <div className="retrocheck-filters__input">
                                        <Field
                                            name="PatientNameContains"
                                            render={({ field }) => (
                                                <InputField
                                                    id={field.name}
                                                    title={"Patient Name"}
                                                    placeholder={"Patient Name"}
                                                    {...field}
                                                    onBlur={e => {
                                                        setFieldValue(field.name, e.currentTarget.value.toString().trim());
                                                    }}
                                                />
                                            )}
                                        />
                                    </div>
                                    <div className="retrocheck-filters__input">
                                        <Field
                                            name="Mrn"
                                            render={({ field }) => (
                                                <InputField
                                                    id={field.name}
                                                    title={"MRN"}
                                                    placeholder={"MRN"}
                                                    {...field}
                                                    onBlur={e => {
                                                        setFieldValue(field.name, e.currentTarget.value.toString().trim());
                                                    }}
                                                />
                                            )}
                                        />
                                    </div>
                                    <div className="retrocheck-filters__input">
                                        <Field
                                            name="AccountId"
                                            render={({ field }) => (
                                                <InputField
                                                    id={field.name}
                                                    title={"Account Id"}
                                                    placeholder={"Account Id"}
                                                    {...field}
                                                    onBlur={e => {
                                                        setFieldValue(field.name, e.currentTarget.value.toString().trim());
                                                    }}
                                                />
                                            )}
                                        />
                                    </div>
                                    <div className="retrocheck-filters__input">
                                        <Field
                                            name="RecordStatus"
                                            render={({ field }) => (
                                                <SimpleSingleSelect
                                                    {...field}
                                                    title={`Record Status`}
                                                    setFieldValue={setFieldValue}
                                                    setFieldTouched={setFieldTouched}
                                                    options={[
                                                        "Processed",
                                                        "Error",
                                                    ]}
                                                />
                                            )}
                                        />
                                    </div>
                                    <div className="retrocheck-filters__input">
                                        <Field
                                            name="CoverageStatus"
                                            render={({ field }) => (
                                                <SimpleSingleSelect
                                                    {...field}
                                                    setFieldTouched={setFieldTouched}
                                                    title={`Coverage Status`}
                                                    setFieldValue={setFieldValue}
                                                    options={[
                                                        { label: "Found", value: true },
                                                        { label: "Not Found", value: false }
                                                    ]}
                                                />
                                            )}
                                        />
                                    </div>
                                    <div className="retrocheck-filters__input">
                                        <Field
                                            name="movedToMarketplace"
                                            render={({ field }) => (
                                                <div className="retrocheck__check-box">
                                                    <LabelledCheckbox
                                                        {...field}
                                                        labelText={"Show Records That Are Moved To Marketplace"}
                                                        id={field.name}
                                                        value={field.name}
                                                        checked={field.value === true}
                                                        {...props}
                                                    />
                                                </div>
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="retrocheck-filters__submit">
                                <CTA
                                    size={"medium"}
                                    styleType={"blue"}
                                    click={() => {
                                        handleSubmit(values);
                                    }}
                                >
                                    Submit
                                </CTA>
                            </div>
                        </form>
                    </div>
                );
            }}
        />
    );
};
